module.exports = __webpack_public_path__ + "static/media/yhc.96a6ed54.jpg";